import React, { Component } from 'react'
import { isAuthenticated, getProfile } from 'tools/user'
import PropTypes from 'prop-types'
import { SubscriptionClient } from 'subscriptions-transport-ws'
import WebSocket from 'isomorphic-ws'
import RootErrorBoundary from 'atoms/RootErrorBoundary'
import { settings } from 'contexts/settings-context'
import { query } from 'tools/fetch'

const { Provider, Consumer } = React.createContext({})

const BALANCE_QUERY = `
query WalletBalance {
    currentUser {
        wallet {
            playableBalance
            bonuses {
                offerPublicId
                balance
                applicableClients
                redirectUri
                destinationUri
                claimedAt
                bonusAmount
            }
        }
    }
}`

const BALANCE_SUBSCRIPTION_QUERY = `
subscription WalletBalanceUpdates {
    walletBalanceChanged {
        userUuid
    }
}`

class ProfileProvider extends Component {
  state = {
    profile: null,
    playableBalance: null,
    isAuthenticated: null,
  }

  get walletApiUrl () {
    const { config } = this.props
    const apiUrl = config.walletApiUrl || settings.WALLET_API_URI
    return apiUrl
  }

  get subscriptionApiUrl () {
    return settings.CONNECT_SUBSCRIPTIONS_URI
  }

  componentDidMount () {
    const { config } = this.props
    if (config.suppressAuthUI === true) {
      return // nothing to do here if we don't intend to render any of this.
    }
    const userIsAuthenticated = isAuthenticated(config.idToken)
    const profile = getProfile(config.idToken)
    this.setState({
      profile: profile,
      isAuthenticated: userIsAuthenticated,
    })

    if (!config.accessToken || userIsAuthenticated === false) {
      return
    }

    this.updateBalance()
    this.subscribeToBalance()
    this.addIdentityToDataLayer(profile)
  }

  componentWillUnmount () {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  render () {
    const { profile, playableBalance, bonuses, isAuthenticated } = this.state
    const { children } = this.props

    // if (profile === null && isAuthenticated === null) {
    //     return null
    // }
    return (
      <RootErrorBoundary>
        <Provider value={{ playableBalance, bonuses, isAuthenticated, ...profile }}>
          {children}
        </Provider>
      </RootErrorBoundary>
    )
  }

  async updateBalance () {
    const { config } = this.props

    const queryDetails = {
      uri: this.walletApiUrl,
      accessToken: config.accessToken,
      query: BALANCE_QUERY,
    }

    const data = await query(queryDetails)
    if (data) {
      const { playableBalance, bonuses } = data.currentUser.wallet
      this.setState({ playableBalance, bonuses })
    }
  }

  subscribeToBalance () {
    const { config } = this.props
    const wsOptions = {
      reconnect: true,
      connectionParams: {
        Authorization: `Bearer ${config.accessToken}`,
      },
    }
    const wsClient = new SubscriptionClient(this.subscriptionApiUrl, wsOptions, WebSocket)
    const query = wsClient.request({
      query: BALANCE_SUBSCRIPTION_QUERY,
    })

    this.unsubscribe = query.subscribe((message) => {
      const update = message.data

      if (update.walletBalanceChanged !== undefined) {
        this.updateBalance()
      }
    })
  }

  addIdentityToDataLayer (profile) {
    if (window.dataLayer !== undefined && profile) {
      window.dataLayer.push({
        user: {
          uuid: profile.id,
          email: profile.email,
          username: profile.preferred_username,
          givenName: profile.given_name,
          familyName: profile.family_name,
        },
        event: 'identify',
      })
    }
  }
}

const ProfileConsumer = Consumer

export {
  ProfileProvider,
  ProfileConsumer,
}

ProfileProvider.propTypes = {
  config: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./src/contexts/profile-context.js